const EXAMPLE_TRIP = {
    trips: [
        {
            id: 1,
            name: "Portogallo 2026",
            destination: "Lisbona, Porto, Sintra",
            startDate: "2026-04-15",
            endDate: "2026-04-28",
            image: "🇵🇹",
            currency: "€",
            budget: 1500,
            cities: [
                {
                    name: "Lisbona",
                    hotel: {
                        name: "The Independente Hostel",
                        address: "Rua de São Pedro de Alcântara 81, Lisbona",
                        rating: 4.5,
                        price: 85,
                        notes: "Boutique hostel nel quartiere di Príncipe Real",
                        bookingLink: "https://www.booking.com/...",
                        mapsLink: "https://maps.google.com/..."
                    },
                    days: [
                        {
                            date: "2026-04-15",
                            location: "Bairro Alto e Príncipe Real",
                            city: "Lisbona",
                            activities: [
                                {
                                    time: "09:00",
                                    name: "Arrivo aeroporto di Humberto Delgado",
                                    cost: 0,
                                    type: "transport",
                                    notes: "Aeroporto principale di Lisbona",
                                    image: "",
                                    link: "",
                                    from: "Aeroporto",
                                    to: "Hotel",
                                    distance: 10
                                },
                                {
                                    time: "11:30",
                                    name: "Check-in hotel",
                                    cost: 0,
                                    type: "check-in",
                                    notes: "Deposito bagagli se early check-in non disponibile",
                                    image: "",
                                    link: ""
                                },
                                {
                                    time: "14:00",
                                    name: "Castelo de São Jorge",
                                    cost: 15,
                                    type: "activity",
                                    notes: "Vista panoramica su Lisbona. Aperto 9:00-21:00",
                                    image: "",
                                    link: "https://www.castelodesaojorge.pt/"
                                },
                                {
                                    time: "20:00",
                                    name: "Cena tipica portoghese",
                                    cost: 30,
                                    type: "food",
                                    notes: "Bacalhau e vino verde",
                                    image: "",
                                    link: ""
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
};

export const EXAMPLE_JSON = JSON.stringify(EXAMPLE_TRIP, null, 2);
